if (!customElements.get('header-component')) {
    customElements.define('header-component', class HeaderComponent extends HTMLElement {
        constructor() {
            super();
            this.mobileMenu = this.querySelector('.header__mobile');
            this.closeMenu = this.querySelector('[mobile-close]');
            this.openMenu = this.querySelector('[mobile-opener]');
            this.submenuBackBtns = this.querySelectorAll('.mega-menu__back-btn');
            this.initEvents();
        }
        initEvents(){
            this.closeMenu.addEventListener('click', ()=> this.mobileMenu.removeAttribute('open'));
            this.openMenu.addEventListener('click', ()=> this.mobileMenu.setAttribute('open', true));
            this.submenuBackBtns.forEach(btn => {
                btn.addEventListener('click', ()=> btn.closest('details').removeAttribute('open') )
            })
        }
        
        connectedCallback() {
            this.header = document.querySelector('.shopify-section__header');
            this.headerIsAlwaysSticky = false;
            this.headerBounds = {};
    
            this.setHeaderHeight();
    
            window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    
            if (this.headerIsAlwaysSticky) {
                this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('search-component');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
    
        setHeaderHeight() {
            document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
    
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
    
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
            });
    
            observer.observe(this.header);
        }
    
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
    
                        this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);
    
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
    
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.closeMenuDisclosure();
            // this.closeSearchModal();
        }
    
        reveal() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
        }
    
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        }
    
        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
    
        closeSearchModal() {
            this.searchModal = this.searchModal || this.header.querySelector('details-modal');
            this.searchModal.close(false);
        }
    });
}
if (!customElements.get('search-component')) {
    customElements.define('search-component', class HeaderComponent extends HTMLElement {
        constructor() {
            super();
            this.input = this.querySelector('#search-input');
            this.label = this.querySelector('label');
            this.overlay = this.querySelector('.search-overlay');
            this.form = this.querySelector('form');
            this.predictiveSearchResults = this.querySelector('.seach-content__inner-result');
            this.cachedResults = {};
            this.searchTerm = '';
            this.isOpen = false;
            this.initEvents();
        }
        initEvents(){
            this.input.addEventListener('input', debounce((event) => {
                this.onChange(event);
            }, 300).bind(this))
            this.overlay.addEventListener('click', ()=>this.close())
        }
        
        onChange(){
            this.searchTerm =  this.getQuery();
            this.isOpen = true
            if (!this.searchTerm.length) {
                this.close(true);
                return;
            }
            this.classList.add('active');
            this.getSearchResults(this.searchTerm);
        }
        
        getQuery() {
            return this.input.value.trim();
        }
        
        getSearchResults(searchTerm){
            const queryKey = searchTerm.replace(" ", "-").toLowerCase();
            if (this.cachedResults[queryKey]) {
                this.renderSearchResults(this.cachedResults[queryKey]);
                return;
            }
            
            fetch(
                `${routes.predictive_search_url}?q=${encodeURIComponent(
                searchTerm
                )}&section_id=predictive-search`,
                // { signal: this.abortController.signal }
            )
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }
                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                // Save bandwidth keeping the cache in all instances synced
                this.cachedResults[queryKey] = resultsMarkup;
                this.renderSearchResults(resultsMarkup);
            })
            .catch((error) => {
                if (error?.code === 20) {
                    // Code 20 means the call was aborted
                    return;
                }
                this.close();
                throw error;
            });
        }
        
        renderSearchResults(resultsMarkup){
            this.predictiveSearchResults.innerHTML = resultsMarkup;
            this.setAttribute('results', true);
        }
        close(){
            this.classList.remove('active');
            this.removeAttribute('results');
            this.form.reset();
            this.predictiveSearchResults.innerHTML = '';
            this.isOpen = false;
        }
    });
}

let closeAnnoncement = document.querySelector('.close-annoncement');
closeAnnoncement?.addEventListener('click', function(){
    let annoncement = document.querySelector(closeAnnoncement.getAttribute('parent'));
    annoncement?.remove();
})